import { Routes, Route } from "react-router-dom";
import { isEntidadeS3ouS4, Papel } from "../auth/entidadeUsuario";
import { hasPermissao } from "../auth/entidadeUsuario";

import Error from "../pages/Error";
import Home from "../pages/Home";

// Rotas Pessoas Certificadoras e certificados
import CertificadorasCadastrar from "../views/Certificadoras/Cadastrar";
import CertificadorasPessoaJuridicaConsultar from "../views/Certificadoras/ConsultarPessoaJuridica";
import CertificadorasConsultar from "../views/Certificadoras/ConsultarCertificadora";
import CertificadorasManter from "../views/Certificadoras/Manter";

// Rotas Diretores
import DiretorCadastrar from "../views/Mandato/Diretor/Cadastrar";
import DiretorConsultar from "../views/Mandato/Diretor/ConsultarDiretor";
import DiretorManter from "../views/Mandato/Diretor/Manter";

// Rotas Conselheiros
import ConselheiroCadastrar from "../views/Mandato/Conselheiro/Cadastrar";
import ConselheiroConsultar from "../views/Mandato/Conselheiro/ConsultarConselheiro";
import ConselheiroManter from "../views/Mandato/Conselheiro/Manter";

// Rotas Outros Cargos
import OutroCargoCadastrar from "../views/OutroCargo/Cadastrar";
import OutroCargoConsultar from "../views/OutroCargo/ConsultarOutroCargo";
import OutroCargoManter from "../views/OutroCargo/Manter";

// Rotas Dirigente Excepcional
import DirigenteExcepcionalCadastrar from "../views/DirigenteExcepcional/Cadastrar";
import DirigenteExcepcionalConsultar from "../views/DirigenteExcepcional/ConsultarDirigenteExcepcional";
import DirigenteExcepcionalManter from "../views/DirigenteExcepcional/Manter";

// Rotas Pessoas Físicas
import PessoaFisicaConsultar from "../views/PessoaFisica/ConsultarPessoaFisica";
import PessoaFisicaCadastrar from "../views/PessoaFisica/Cadastrar";
import PessoaFisicaManter from "../views/PessoaFisica/Manter";
import ConsultarParaCadastrar from "../views/PessoaFisica/ConsultarParaCadastrar";
import Debug from "../pages/Debug";


const AppRoutes = () => {
  return (
      <Routes>
          <Route path="/home" element={<Home />} />

          {hasPermissao([Papel.DILIC_MASTER, Papel.DILIC_USUARIO, Papel.DICOL_CGDC, Papel.DIFIS_CGRE, Papel.PREVIC_CONSULTAR, Papel.ENTIDADE_ALTERAR, Papel.ENTIDADE_CONSULTAR]) && (
            <>
              <Route
                path="/pessoa-fisica/consultar"
                element={<PessoaFisicaConsultar />}
              />

              <Route
                path="/pessoa-fisica/manter"
                element={<PessoaFisicaManter />}
              />
            </>
          )}
          {hasPermissao([Papel.DILIC_MASTER, Papel.DILIC_USUARIO, Papel.ENTIDADE_ALTERAR]) && (
            <Route
              path="/pessoa-fisica/cadastrar"
              element={<PessoaFisicaCadastrar />}
            />
          )}

          {hasPermissao([Papel.DILIC_MASTER, Papel.DILIC_USUARIO, Papel.DICOL_CGDC, Papel.DIFIS_CGRE, Papel.PREVIC_CONSULTAR, Papel.ENTIDADE_ALTERAR, Papel.ENTIDADE_CONSULTAR]) && (<>
            <Route
              path="/dirigente/conselheiro/consultar"
              element={<ConselheiroConsultar />}
            />
            <Route
              path="/dirigente/conselheiro/manter"
              element={<ConselheiroManter />}
            />
          </>)}
          {(hasPermissao([Papel.DILIC_MASTER, Papel.DILIC_USUARIO]) || isEntidadeS3ouS4() ) && (<>
            <Route
              path="/dirigente/conselheiro/consultarpessoafisica"
              element={<ConsultarParaCadastrar tipoMandato="Conselheiro" caminhoCadastro="/dirigente/conselheiro/cadastrar" />}
            />
            <Route
              path="/dirigente/conselheiro/cadastrar"
              element={<ConselheiroCadastrar />}
            />
          </>)}

          {hasPermissao([Papel.DILIC_MASTER, Papel.DILIC_USUARIO, Papel.DICOL_CGDC, Papel.DIFIS_CGRE, Papel.PREVIC_CONSULTAR, Papel.ENTIDADE_ALTERAR, Papel.ENTIDADE_CONSULTAR]) && (<>
            <Route
              path="/dirigente/diretor/consultar"
              element={<DiretorConsultar />}
            />
            <Route
              path="/dirigente/diretor/manter"
              element={<DiretorManter />}
            />
          </>)}
          {hasPermissao([Papel.DILIC_MASTER, Papel.DILIC_USUARIO]) && (<>
            <Route
              path="/dirigente/diretor/consultarpessoafisica"
              element={<ConsultarParaCadastrar tipoMandato="Diretor" caminhoCadastro="/dirigente/diretor/cadastrar" />}
            />
            <Route
              path="/dirigente/diretor/cadastrar"
              element={<DiretorCadastrar />}
            />
          </>)}

          {hasPermissao([Papel.DILIC_MASTER, Papel.DILIC_USUARIO, Papel.DICOL_CGDC, Papel.DIFIS_CGRE, Papel.PREVIC_CONSULTAR, Papel.ENTIDADE_ALTERAR, Papel.ENTIDADE_CONSULTAR]) && (<>
            <Route
              path="/dirigente-excepcional/consultar"
              element={<DirigenteExcepcionalConsultar />}
            />
            <Route
              path="/dirigente-excepcional/manter"
              element={<DirigenteExcepcionalManter />}
            />
          </>)}
          {hasPermissao([Papel.DILIC_MASTER, Papel.DIFIS_CGRE]) && (<>
            <Route
              path="/dirigente-excepcional/consultarpessoafisica"
              element={<ConsultarParaCadastrar tipoMandato="Dirigente Excepcional" caminhoCadastro="/dirigente-excepcional/cadastrar" />}
            />
            <Route
              path="/dirigente-excepcional/cadastrar"
              element={<DirigenteExcepcionalCadastrar />}
            />
          </>)}

          {hasPermissao([Papel.DILIC_MASTER, Papel.DILIC_USUARIO, Papel.DICOL_CGDC, Papel.DIFIS_CGRE, Papel.PREVIC_CONSULTAR, Papel.ENTIDADE_ALTERAR, Papel.ENTIDADE_CONSULTAR]) && (<>
            <Route
              path="/outro-cargo/consultar"
              element={<OutroCargoConsultar />}
            />
            <Route
              path="/outro-cargo/manter"
              element={<OutroCargoManter />}
            />
          </>)}
          {hasPermissao([Papel.DILIC_MASTER, Papel.DILIC_USUARIO, Papel.ENTIDADE_ALTERAR]) && (<>
            <Route
              path="/outro-cargo/consultarpessoafisica"
              element={<ConsultarParaCadastrar tipoMandato="Outros Cargos" caminhoCadastro="/outro-cargo/cadastrar" />}
            />
            <Route
              path="/outro-cargo/cadastrar"
              element={<OutroCargoCadastrar />}
            />
          </>)}

          {hasPermissao([Papel.DILIC_MASTER, Papel.DILIC_USUARIO, Papel.DICOL_CGDC, Papel.DIFIS_CGRE, Papel.PREVIC_CONSULTAR]) && (<>
            <Route
              path="/certificadoras/consultarcertificadora"
              element={<CertificadorasConsultar />}
            />
            <Route
              path="/certificadoras/manter"
              element={<CertificadorasManter />}
            />
          </>)}
          {hasPermissao([Papel.DILIC_MASTER, Papel.DILIC_USUARIO]) && (<>
            <Route
              path="/certificadoras/consultarpessoajuridica"
              element={<CertificadorasPessoaJuridicaConsultar />}
            />
            <Route
              path="/certificadoras/cadastrar"
              element={<CertificadorasCadastrar />}
            />
          </>)}

          {hasPermissao([Papel.DILIC_MASTER, Papel.DILIC_USUARIO, Papel.DICOL_CGDC, Papel.DIFIS_CGRE, Papel.PREVIC_CONSULTAR]) && (<>
            <Route
              path="/debug"
              element={<Debug />}
            />
          </>)}

          <Route path="*" element={<Error />} />
      </Routes>
  );
};

export default AppRoutes;
